'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('friartux/product/details'));
    processInclude(require('friartux/product/wishlist'));
    processInclude(require('friartux/components/inputDate'));
    processInclude(require('friartux/thirdParty/image-zoom'));
    processInclude(require('friartux/components/pdfModalViewer'));
    processInclude(require('replica/components/aiTryOn'));
    processInclude(require('replica/components/feedback'));
});
